import React from 'react';
import { useTranslation } from '../../i18n/useTranslation';
import styles from './CalendarModal.module.css';

function CalendarModalFrame({
  title,
  onClose,
  children,
  overlayClassName = '',
  panelClassName = '',
  headerClassName = '',
  panelStyle,
}) {
  const { t } = useTranslation();
  const stopPropagation = (event) => event.stopPropagation();

  return (
    <div
      className={`${styles.overlay} ${overlayClassName}`.trim()}
      tabIndex="-1"
      onClick={onClose}
    >
      <section
        className={`${styles.panel} ${panelClassName}`.trim()}
        role="dialog"
        aria-modal="true"
        aria-label={typeof title === 'string' ? title : undefined}
        onClick={stopPropagation}
        style={panelStyle}
      >
        <header className={`${styles.header} ${headerClassName}`.trim()}>
          <h3 className={styles.title}>{title}</h3>
          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            aria-label={t('common.close')}
          >
            ×
          </button>
        </header>
        {children}
      </section>
    </div>
  );
}

export default CalendarModalFrame;
